import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css"; // Ensure correct path for styles

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - CIN & Links */}
        <div className="footer-left">
          <p>CIN Number: U52292KA2025PTC204179</p>
          <p>
            <Link to="/privacy-statement" className="footer-link">
              Privacy Statement
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-use" className="footer-link">
              Terms Of Use
            </Link>
          </p>
        </div>

        {/* Center - Copyright (Centered on Large Screens, Last on Small Screens) */}
        <div className="footer-center">
          <p>© {new Date().getFullYear()} <strong>ECL Shipping India Pvt Ltd.</strong></p>
          <p className="footer-developed-by">Developed by ONEVEGA AI Solution Pvt Ltd.</p>
        </div>

        {/* Right Section - Registered Office */}
        <div className="footer-right">
          <p><strong>Registered Office</strong></p>
          <p>ECL Shipping India Pvt Ltd.</p>
          <p>Puyvast House Ground Floor #6, Harris Road, Benson Town Bangalore - 560046, Karnataka, India</p>
          <p><b>Contact No :</b> (080) 23335551</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;